<template>
  <div class="skeleton" :class="[`skeleton--${variant}`, { 'skeleton--animated': animated }]">
    <div v-if="variant === 'text'" class="skeleton__text" :style="{ width: width, height: height }"></div>
    <div v-else-if="variant === 'circle'" class="skeleton__circle" :style="{ width: size, height: size }"></div>
    <div v-else-if="variant === 'rect'" class="skeleton__rect" :style="{ width: width, height: height }"></div>
    <div v-else-if="variant === 'proposal'" class="skeleton__proposal">
      <div class="skeleton__proposal-header">
        <div class="skeleton__text skeleton__text--title"></div>
        <div class="skeleton__text skeleton__text--subtitle"></div>
      </div>
      <div class="skeleton__proposal-content">
        <div class="skeleton__text" v-for="i in 5" :key="i"></div>
      </div>
      <div class="skeleton__proposal-items">
        <div class="skeleton__rect skeleton__rect--item" v-for="i in 3" :key="i"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    variant: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'circle', 'rect', 'proposal'].includes(value),
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '1rem',
    },
    size: {
      type: String,
      default: '40px',
    },
    animated: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
.skeleton {
  &--animated {
    .skeleton__text,
    .skeleton__circle,
    .skeleton__rect {
      background: linear-gradient(
        90deg,
        var(--slate-200) 25%,
        var(--slate-100) 50%,
        var(--slate-200) 75%
      );
      background-size: 200% 100%;
      animation: skeleton-loading 1.5s ease-in-out infinite;
    }
  }

  &__text,
  &__circle,
  &__rect {
    background-color: var(--slate-200);
    border-radius: 4px;
  }

  &__text {
    height: 1rem;
    margin-bottom: 0.5rem;

    &--title {
      height: 1.5rem;
      width: 60%;
      margin-bottom: 0.75rem;
    }

    &--subtitle {
      height: 1.25rem;
      width: 40%;
      margin-bottom: 1rem;
    }
  }

  &__circle {
    border-radius: 50%;
  }

  &__rect {
    &--item {
      height: 80px;
      margin-bottom: 1rem;
    }
  }

  &__proposal {
    padding: 1.5rem;

    &-header {
      margin-bottom: 2rem;
    }

    &-content {
      margin-bottom: 2rem;
    }

    &-items {
      margin-top: 2rem;
    }
  }
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
